<input type="checkbox" [id]="id" khA11yField [khA11yLabel]="accessibleLabel" [(ngModel)]="model" (blur)="onBlur()">
<label [class.cursor]="isClickableLabel" [for]="id"></label>
